import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Eye } from "lucide-react";

const getStatusColor = (status) => {
  if (["approved", "registered", "attended"].includes(status)) return "bg-success/10 text-success border-success/20";
  if (["rejected", "not_attended", "cancelled"].includes(status)) return "bg-destructive/10 text-destructive border-destructive/20";
  if (["received", "under_review"].includes(status)) return "bg-warning/10 text-warning border-warning/20";
  return "bg-muted";
};

export default function AdminApplications() {
  const [apps, setApps] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  
  useEffect(() => { api.get(`${V1}/admin/applications`).then((r) => setApps(r.data || [])); }, []);

  return (
    <div className="space-y-6" data-testid="admin-applications-page">
      <div>
        <div className="overline text-accent">Yönetim</div>
        <h1 className="font-display text-3xl font-bold">Tüm Başvurular</h1>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Başvuru</th>
              <th className="text-left p-3">Okul</th>
              <th className="text-left p-3">Tarih</th>
              <th className="text-left p-3">Durum</th>
              <th className="text-right p-3">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {apps.length === 0 && <tr><td colSpan={5} className="p-8 text-center text-muted-foreground">Başvuru yok.</td></tr>}
            {apps.map((a) => (
              <tr key={a.id} className="border-t border-border">
                <td className="p-3 font-mono text-xs">{a.application_no}</td>
                <td className="p-3 font-mono text-xs">{a.school_id?.slice(0, 8)}</td>
                <td className="p-3">{new Date(a.created_at).toLocaleDateString("tr-TR")}</td>
                <td className="p-3"><span className={`px-2 py-0.5 border rounded text-xs uppercase font-medium ${getStatusColor(a.status)}`}>{a.status}</span></td>
                <td className="p-3 text-right">
                  <Button size="sm" variant="outline" onClick={() => setSelectedApp(a)}>
                    <Eye className="h-4 w-4 mr-2" /> Detay
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!selectedApp} onOpenChange={(open) => !open && setSelectedApp(null)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Başvuru Detayı</DialogTitle>
          </DialogHeader>
          {selectedApp && (
            <div className="space-y-4 text-sm mt-4">
              <div className="grid grid-cols-2 gap-2">
                <div className="text-muted-foreground">Başvuru No:</div>
                <div className="font-mono">{selectedApp.application_no}</div>
                
                <div className="text-muted-foreground">Öğrenci Adı:</div>
                <div>{selectedApp.student_name}</div>
                
                <div className="text-muted-foreground">Veli Adı:</div>
                <div>{selectedApp.parent_name}</div>
                
                <div className="text-muted-foreground">İletişim:</div>
                <div>{selectedApp.contact_email} {selectedApp.contact_phone && ` / ${selectedApp.contact_phone}`}</div>
                
                <div className="text-muted-foreground">Okul ID:</div>
                <div className="font-mono">{selectedApp.school_id}</div>
                
                <div className="text-muted-foreground">Sınav ID:</div>
                <div className="font-mono">{selectedApp.exam_id}</div>
                
                <div className="text-muted-foreground">Durum:</div>
                <div><span className={`px-2 py-0.5 border rounded text-xs uppercase font-medium ${getStatusColor(selectedApp.status)}`}>{selectedApp.status}</span></div>
                
                <div className="text-muted-foreground">Tarih:</div>
                <div>{new Date(selectedApp.created_at).toLocaleString("tr-TR")}</div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
